import React, { Component } from 'react'

export default class Loadding extends Component {
    render() {
        return (
          
            <div class="spinner-border text-center" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          
        )
    }
}
